import React, { useEffect, useState } from "react";
import { Icon } from "../../icons/icons";
import PaginationItem from "./PaginationItem";

const Pagination = ({ setPage, currentPage, totalPage }) => {
  const Showed = 6;
  const PerSide = Showed / 2;

  const [pages, setPages] = useState([]);

  useEffect(() => {
    const start =
      currentPage == 1
        ? 1
        : currentPage >= totalPage
        ? currentPage - PerSide + 1
        : currentPage - 1;
    const arr = [];
    if (totalPage <= 3) {
      for (let i = 1; i <= totalPage; i++) {
        arr.push(i);
      }
    } else {
      for (let i = 0; i <= 2; i++) {
        arr.push(start + i);
      }
    }
    setPages(arr);
  }, [currentPage, totalPage]);

  return (
    <ul className="flex justify-center gap-x-0.5 ml:gap-x-4 mt-4">
      {currentPage != 1 && (
        <PaginationItem setPage={setPage} page={currentPage - 1}>
          <Icon name={"PaginationPrev"} className={"w-2"}></Icon>
        </PaginationItem>
      )}

      {currentPage > PerSide && (
        <PaginationItem setPage={setPage} page={1}>
          {1}
        </PaginationItem>
      )}
      {currentPage > PerSide && <PaginationItem>. . .</PaginationItem>}

      {pages.map((e, i) => (
        <PaginationItem
          key={i}
          setPage={setPage}
          page={e}
          active={e == currentPage}
        >
          {e}
        </PaginationItem>
      ))}

      {currentPage <= totalPage - PerSide + 1 && totalPage > PerSide && (
        <PaginationItem>. . .</PaginationItem>
      )}

      {/* {currentPage <= totalPage - PerSide + 1 && totalPage > PerSide && (
        <PaginationItem setPage={setPage} page={totalPage}>
          {totalPage}
        </PaginationItem>
      )} */}

      {currentPage != totalPage && (
        <PaginationItem setPage={setPage} page={currentPage + 1}>
          <Icon name={"PaginationNext"} className={"w-2"}></Icon>
        </PaginationItem>
      )}

      {/* {Array.from(Array(PerSide).keys()).map((e, i) => (
        <PaginationItem setPage={setPage} page={FindEndPosition() + i} key={i}>
          {FindEndPosition() + i}
        </PaginationItem>
      ))} */}
    </ul>
  );
};

export default Pagination;
